import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { InputComponent } from "@components/input/input.component";
import { ITplDestinering } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplDestineringFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-redovisningshanvisning-filter",
    templateUrl: "./tpl-redovisningshanvisning-filter.component.html",
    styleUrls: ["./tpl-redovisningshanvisning-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        InputComponent
    ]
})
export class TplRedovisningshanvisningFilterComponent
    extends FilterBaseComponent
    implements OnInit, ITplDestineringFilter {
    constructor() {
        super("redovisningshanvisning");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl(null));
    }

    onFilterInit(state: string): void {
        this.control.setValue(state);
    }

    match(item: ITplDestinering): boolean {
        const value = this.value()?.toLowerCase().trim();
        return item.redovisningshanvisning.some((x) =>
            x?.toLowerCase().includes(value)
        );
    }

    value(): string {
        return this.control.value;
    }

    isActive(): boolean {
        return !!this.value();
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addDestineringFilter(this.name, this);
    }

    protected onFormChange(value: string): void {
        this.filterLength = value ? 1 : 0;
    }
}
